import { useSearchParams } from 'react-router';
import LayoutAdmin from '../../components/layouts/LayoutAdmin';
import NavTab from '../../components/NavTab';
import Tour from './tour/PageTourPackage';
import Insurance from './insurance/PageInsurance';
import Other from './other/PageOtherProduct';

export default function Product() {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('page') || 'Tour Package';

  return (
    <LayoutAdmin header="Product">
      <NavTab tabs={['Tour Package', 'Insurance', 'Other']} />

      {activeTab === 'Tour Package' && <Tour />}
      {activeTab === 'Insurance' && <Insurance />}
      {activeTab === 'Other' && <Other />}
    </LayoutAdmin>
  );
}
